import React, { useEffect, useState } from 'react'
import NavigationAdmin from '../navigation-admin/NavigationAdmin'
import "./Admin.css"
import CalendarPage from '../../pages/CalendarPage/CalendarPage'
import ProductsPage from '../../pages/ProductsPage/ProductsPage';
import ServicesPage from '../../pages/ServicesPage/ServicesPage';
import SettingsPage from '../../pages/SettingsPage/SettingsPage';
import Patients from '../../pages/Patients/Patients';
import NotificationsPage from '../../pages/NotificationsPage/NotificationsPage';
import MisCitas from '../../pages/MisCitas/MisCitas';
import SettingsPlus from '../settings-plus/SettingsPlus';

export default function Admin() {
    const [page, setPage] = useState("");
    const [fullname, setFulname] = useState("");
    const [type, setType] = useState("");
    const [mail, setMail] = useState("");


    const settingPage = (page) => {
        setPage(page);
    }

    const getUserInfo = () => {
        // TODO: Implementar la lógica para obtener la información del usuario
        const user = localStorage.getItem("vitaly_user");
        console.log("User info:", JSON.parse(user));
        const dataUser = JSON.parse(user);
        setFulname(dataUser.fullName);
        setType(dataUser.type);
        setMail(dataUser.email);

        if (dataUser.type == "personal") {
            setPage("mis-citas");
        } else {
            setPage("calendar");
        }
    }

    useEffect(() => {
        getUserInfo()
    }, [])

    return (
        <div className='admin-site'>

            <NavigationAdmin
                page={page}
                settingPage={settingPage}
                fullname={fullname}
                type={type}
                mail={mail}
            />

            {page === "calendar" && <CalendarPage />}
            {page === "products" && <ProductsPage />}
            {page === "services" && <ServicesPage />}
            {page === "mis-citas" && <MisCitas />}
            {page === "patients" && <Patients />}
            {page === "settings" && <SettingsPage />}
            {page === "profile" && <CalendarPage />}
            {page === "notifications" && <NotificationsPage />}
            {page === "settings-plus" && <SettingsPlus />}

        </div>
    )
}
